import type {Container} from 'inversify'

/**
 * This allows a user to user $inj('ServiceName') to get the instance of the service for debugging purposes.
 * @param window -- the global window object
 * @param container -- the inversify DI container we will be searching
 */
export function registerConsoleInject(window: Window, container: Container) {
  (window as any).$inj = provideInjectByString(container);
}

function isConstructor(value: any): value is Function {
  return typeof value === 'function' && value.prototype && value.prototype.constructor;
}

function getInjectName(it: unknown): string {

  if(isConstructor(it)) {
    return it.name
  }

  if(typeof it === 'symbol') {
    return  it.description ?? ''
  }

  return undefined ?? ''

}

function getAllInjectNames(dictionary: any): string[] {
  return [...dictionary.keys()].map((it: unknown) => getInjectName(it))
}

function provideInjectByString(container: Container) {
  return function(typeName: string) {

    const dictionary: any = (container as any)._bindingDictionary._map

    const match = [...dictionary.keys()].find((it: unknown) => getInjectName(it) === typeName)

    if(match) {
      console.log('match: ', match)
      return container.get(match)
    } else {
      const allInjectNames = getAllInjectNames(dictionary)
      console.log('no matches found, possible inject names are: ', allInjectNames)
      return null
    }

  }
}
